<ng-container *ngIf="isPrimary; else isSecondary">
  <udex-button
    #addToCartButton
    size="Large"
    design="Primary"
    [disabled]="!priceData || showSpinner || isDisabled"
    (click)="addToCartButton.blur(); addToCart(product)"
  >
    <span
      *ngIf="!showSpinner; else spinner"
    >
      {{ btnTranslationKey | cxTranslate }}
    </span>
    <ng-template #spinner>
      <ui5-busy-indicator
        size="Medium"
        class="white-dots d-flex"
        active></ui5-busy-indicator>
    </ng-template>
  </udex-button>
</ng-container>

<ng-template #isSecondary>
  <udex-button
    #addToCartButton
    size="Large"
    design="Secondary"
    [disabled]="!priceData || showSpinner || isDisabled"
    (click)="addToCartButton.blur(); addToCart(product)"
  >
      <span
        *ngIf="!showSpinner; else spinner"
      >
      {{ btnTranslationKey | cxTranslate }}
    </span>
    <ng-template #spinner>
      <ui5-busy-indicator
        size="Medium"
        class="d-flex"
        active></ui5-busy-indicator>
    </ng-template>
  </udex-button>


</ng-template>
